import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosPrestamoPlazosComponent {
    desglose = {}
    limite
    form

    $onInit() {
      let length = (this.desglose.length)-1;
      this.limite = this.desglose[length].desgloseFechaFinal;
    }
    
    actualizarLimite(last, fechaFinal){
      if(new Date(fechaFinal)){
        if(last){
          this.limite = fechaFinal
        }
      }
    }
}

module.component('colaboradorPrestamosExternosPrestamoPlazos', {
  controller: ColaboradorPrestamosExternosPrestamoPlazosComponent,
  template,
  bindings: {
    desglose: '<',
    form: '<',
  },
})


// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/prestamo/plazos/component.js